import { ActionCategory } from "@/generated/core/v1/actions";
import { CATEGORY_LABEL } from "@/plan-logic/plan-view/categories";

/** Labels and colours for the plan's action categories (the prototype's DSTC/DSTN). */
export const CATEGORY: Record<ActionCategory, { label: string; color: string }> = {
  [ActionCategory.ESSENTIAL]: {
    label: CATEGORY_LABEL[ActionCategory.ESSENTIAL],
    color: "var(--ess)",
  },
  [ActionCategory.HOUSING]: {
    label: CATEGORY_LABEL[ActionCategory.HOUSING],
    color: "color-mix(in srgb, var(--ess) 60%, var(--card))",
  },
  [ActionCategory.LIFESTYLE]: {
    label: CATEGORY_LABEL[ActionCategory.LIFESTYLE],
    color: "var(--life)",
  },
  [ActionCategory.DEBT_MINIMUM]: {
    label: CATEGORY_LABEL[ActionCategory.DEBT_MINIMUM],
    color: "var(--debt)",
  },
  [ActionCategory.DEBT_EXTRA]: {
    label: CATEGORY_LABEL[ActionCategory.DEBT_EXTRA],
    color: "color-mix(in srgb, var(--debt) 60%, var(--card))",
  },
  [ActionCategory.PRIORITY]: {
    label: CATEGORY_LABEL[ActionCategory.PRIORITY],
    color: "var(--gold-deep, var(--after))",
  },
  [ActionCategory.SAVING]: { label: CATEGORY_LABEL[ActionCategory.SAVING], color: "var(--save)" },
  [ActionCategory.WITHDRAWAL]: {
    label: CATEGORY_LABEL[ActionCategory.WITHDRAWAL],
    color: "var(--ink3)",
  },
  [ActionCategory.OTHER]: { label: CATEGORY_LABEL[ActionCategory.OTHER], color: "var(--ink3)" },
  [ActionCategory.UNSPECIFIED]: {
    label: CATEGORY_LABEL[ActionCategory.UNSPECIFIED],
    color: "var(--ink3)",
  },
};
